import { render, staticRenderFns } from "./BLFee.vue?vue&type=template&id=58a22824&"
import script from "./BLFee.vue?vue&type=script&lang=js&"
export * from "./BLFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports